export type InviteAccountAction = 'create' | 'verify' | 'adopt';
export type CreateConflictAction = 'adopt' | 'retry';

/**
 * Staff invitation account resolution.
 * Invitation emails are only sent when public.users has no row; auth.users
 * may still exist (portal account, orphan row, half-finished accept).
 */
export function resolveInviteAccountAction(input: {
  profileId: string | null;
  authUserId: string | null;
}): InviteAccountAction {
  if (input.profileId) return 'verify';
  if (input.authUserId) return 'adopt';
  return 'create';
}

export function isAuthUserAlreadyExistsMessage(message: string | null | undefined): boolean {
  const msg = (message ?? '').toLowerCase();
  return msg.includes('already') || msg.includes('registered') || msg.includes('exists');
}

export function isSamePasswordMessage(message: string | null | undefined): boolean {
  const msg = (message ?? '').toLowerCase();
  return msg.includes('should be different') || msg.includes('same password');
}

export function resolveCreateUserConflict(authUserId: string | null): CreateConflictAction {
  return authUserId ? 'adopt' : 'retry';
}
